import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import Global from '../../../customlib/Global';

class ResponseTimeCSAverage extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"CS Average"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(group => {
                            return (
                                    <Paper elevation={2} sx={{mb: "10px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{group.salesName}</strong>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6} textAlign={"left"}>
                                                <Box><strong>{group.leadsCount}</strong> leads</Box>    
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}>
                                                <Box><strong>{Global.formatTime(group.avgResponseTime)}</strong> Average</Box>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default ResponseTimeCSAverage;